import { ClientAndAdvisorTasks } from '../MeetingResults/CustomDisplay/ClientAndAdvisorTasks/ClientAndAdvisorTasks'
import { FutureMeetings } from '../MeetingResults/CustomDisplay/FutureMeetings/FutureMeetings'
import { CustomPreset } from './models'
import { AddMeetingTaskToCRMModal } from '../../../../../views/MeetingSummary/CRM/V2/AddTaskToCRMModal'
import { FamilyTree } from '../MeetingResults/CustomDisplay/FamilyTree/FamilyTree'
import { ConversationTimeline, copyConversationTimeline } from '../MeetingResults/CustomDisplay/ConversationTimeline/ConversationTimeline'
import { FamilyTreeCollapsed } from '../MeetingResults/CustomDisplay/FamilyTree/FamilyTreeCollapsed'
import { ConversationTimelineCollapsed } from '../MeetingResults/CustomDisplay/ConversationTimeline/ConversationTimelineCollapsed'
import { ResultCardHeaderButtonsWithoutEdit } from '../MeetingResults/ResultCard/Header/ResultCardHeaderButtonsWithoutEdit'
import { EmailResultCardHeaderButtons } from '../MeetingResults/ResultCard/Header/EmailResultCardHeaderButtons'
import { AiFeature } from '../../../../../models/AiFeature'
import { AdvisorReferral } from '../MeetingResults/CustomDisplay/AdvisorReferral/AdvisorReferralView'
import { copyAdvisorReferral } from '../MeetingResults/CustomDisplay/AdvisorReferral/utils'
import { copyTasks } from '../MeetingResults/CustomDisplay/ClientAndAdvisorTasks/utils'
import { env } from '../../../../../common/util'

const clientAndAdvisorFollowUpTasks = { dev: '9xbrgp80b4ls6qbx', staging: '9xbrgp80b4ls6qbx', prod: 'cqkkd1xbz240b6b7' }
const futureMeetings = { dev: '0wjli2zuhql13b8c', staging: '70952walunyoh784', prod: 'cvlbyfpvcpn8lm79' }
const conversationTimeline = { dev: 'bexymmkg4wy1bt19', staging: 'bexymmkg4wy1bt19', prod: '1yeurmenhtv0mxsx' }
const familyTree = { dev: '18fjyrkvwljdyu0v', staging: 'acdqro1x32p6wck6', prod: '63v2pjlbax3rlqdh' }
const followUpEmail = { dev: 'aur41tqdihe9u1kd', staging: 'dxq0qfghf7kekksd', prod: 'ekg2bcro6o85d6qw' }
const advisorReferral = { dev: 'ei761cpe41z8xkam', staging: '4xy3da295bfs74oq', prod: '9spy1cuwspkqyroe' }

export const CUSTOM_PRESET_MAPPING: { [key: string]: CustomPreset } = {
  [clientAndAdvisorFollowUpTasks[env]]: {
    display: ClientAndAdvisorTasks,
    crmModal: AddMeetingTaskToCRMModal,
    headerButtons: ResultCardHeaderButtonsWithoutEdit,
    copyResult: copyTasks,
  },
  [futureMeetings[env]]: {
    display: FutureMeetings,
  },
  [conversationTimeline[env]]: {
    display: ConversationTimeline,
    collapsedDisplay: ConversationTimelineCollapsed,
    headerButtons: ResultCardHeaderButtonsWithoutEdit,
    copyResult: copyConversationTimeline,
  },
  [familyTree[env]]: {
    display: FamilyTree,
    collapsedDisplay: FamilyTreeCollapsed,
  },
  [followUpEmail[env]]: {
    headerButtons: EmailResultCardHeaderButtons,
  },
  [advisorReferral[env]]: {
    display: AdvisorReferral,
    headerButtons: ResultCardHeaderButtonsWithoutEdit,
    copyResult: copyAdvisorReferral,
  },
}

export const isAiFeatureClientAndAdvisorFollowUpTasks = (aiFeature: AiFeature) => {
  const { preset: { id: aiFeaturePresetId = '' } = {} } = aiFeature
  return aiFeaturePresetId === clientAndAdvisorFollowUpTasks[env]
}
